import { render, staticRenderFns } from "./TransactionMonitoringPortalFailedByRoute.vue?vue&type=template&id=4d07ee54&scoped=true&"
import script from "./TransactionMonitoringPortalFailedByRoute.vue?vue&type=script&lang=js&"
export * from "./TransactionMonitoringPortalFailedByRoute.vue?vue&type=script&lang=js&"
import style0 from "./TransactionMonitoringPortalFailedByRoute.vue?vue&type=style&index=0&id=4d07ee54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d07ee54",
  null
  
)

export default component.exports